import { FlexyForm, FormStructure } from '@europrocurement/flexy-form';
import { FaOptionIcon, editIcon } from '@europrocurement/l2d-icons';
import { Box, Button } from '@mui/material';
import React from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import {
    boolOptions,
    getBooleanField,
    getDocumentTypeMainFields,
} from '../documentTypeFormStructure';

type DocumentTypeFormProps = {
    onSubmit: (formData: { [key: string]: unknown }) => void;
    onCancel: () => void;
    isFormProcessing: boolean;
};

const DocumentTypeForm: React.FunctionComponent<DocumentTypeFormProps> = function (props) {
    const { onSubmit, onCancel, isFormProcessing } = props;

    const formStructure: FormStructure[] = [
        {
            type: 'header',
            label: (
                <>
                    <FaOptionIcon
                        {...editIcon.props}
                        iconProps={{ style: { marginRight: '5px' } }}
                    />
                    Informations principales
                </>
            ),
            name: 'main_informations',
        },
        ...getDocumentTypeMainFields(),
        getBooleanField({
            name: 'signable',
            inputlabel: 'Signable',
            placeholder: 'Ce document est-il signable ?',
            grid: {
                xs: 12,
                sm: 12,
                md: 4,
                lg: 4,
            },
        }),
        getBooleanField({
            name: 'typageAuto',
            inputlabel: 'Typage automatique',
            placeholder: 'Typage automatique ?',
            grid: {
                xs: 12,
                sm: 12,
                md: 4,
                lg: 4,
            },
        }),
        getBooleanField({
            name: 'vide',
            inputlabel: 'Document vide',
            placeholder: 'Document vide ?',
            grid: {
                xs: 12,
                sm: 12,
                md: 4,
                lg: 4,
            },
        }),
    ];

    const formContext = useForm<FieldValues>({
        mode: 'onTouched',
        defaultValues: {
            signable: boolOptions.find((option) => option.value === false),
            typageAuto: boolOptions.find((option) => option.value === false),
            vide: boolOptions.find((option) => option.value === false),
        },
    });

    const formProps = {
        formContext,
        formObject: {},
        onSubmit,
        submitButton: {
            displayed: false,
        },
    };

    return (
        <>
            <FlexyForm
                formStructure={formStructure}
                {...formProps}
            />
            <Box
                display="flex"
                justifyContent="end"
            >
                <Box
                    display="flex"
                    sx={{ marginTop: '25px' }}
                >
                    <Button
                        variant="outlined"
                        onClick={onCancel}
                        sx={{ marginRight: '15px' }}
                    >
                        Annuler
                    </Button>
                    <Button
                        variant="contained"
                        onClick={formContext.handleSubmit(onSubmit)}
                        disabled={isFormProcessing}
                    >
                        Ajouter un type de document
                    </Button>
                </Box>
            </Box>
        </>
    );
};

export default DocumentTypeForm;
